import React, { useEffect, useState } from 'react'

import { Formik, FormikConfig, FormikProps } from 'formik'
import { FormikHelpers } from 'formik/dist/types'

import { isEmpty } from '@/helpers/type-guards'
import { scrollTo } from '@/helpers/utils'

export const getInitialTouched = initialValues => {
  const values = {}

  Object.keys(initialValues).forEach(key => {
    if (Array.isArray(initialValues[key])) {
      const newArray = initialValues[key].map((object: { [key: string]: string } | string) => {
        if (typeof object === 'object' && object !== null) {
          const newObject = {}
          Object.keys(object).forEach(key => (newObject[key] = true))

          return newObject
        }

        return true
      })

      return (values[key] = newArray)
    }

    return (values[key] = true)
  })

  return values
}
export const changeNullToEmpty = answers => {
  const { __typename, ...filteredAnswers } = answers
  const values = {}

  Object.keys(filteredAnswers).forEach(key => {
    if (Array.isArray(filteredAnswers[key])) {
      const newArray = filteredAnswers[key].map((object: { [key: string]: string }) => {
        if (typeof object === 'object' && object !== null) {
          const { __typename, ...filteredObject } = object
          const newObject = {}
          Object.keys(filteredObject).forEach(key =>
            filteredObject[key] === null || filteredObject[key] === undefined ? (newObject[key] = '') : (newObject[key] = object[key]),
          )

          return newObject
        }

        return object
      })

      return (values[key] = newArray)
    }

    if (filteredAnswers[key] === null || filteredAnswers[key] === undefined) {
      return (values[key] = '')
    }

    return (values[key] = filteredAnswers[key])
  })

  return values
}

export const changeEmptyToNull = answers => {
  const values = {}

  Object.keys(answers).forEach(key => {
    if (Array.isArray(answers[key])) {
      const newArray = answers[key].map((object: { [key: string]: string } | string) => {
        if (typeof object === 'object' && object !== null) {
          const newObject = {}
          Object.keys(object).forEach(key => {
            const val = typeof object[key] === 'string' ? object[key].trim() : object[key]
            newObject[key] = val === '' ? null : val
          })

          return newObject
        }

        return typeof object === 'string' ? object.trim() : object
      })

      return (values[key] = newArray)
    }

    const val = typeof answers[key] === 'string' ? answers[key].trim() : answers[key]

    return (values[key] = val === '' ? null : val)
  })

  return values
}

const Form = <T extends object = {}>({
  initialValues,
  validationSchema,
  onSubmit,
  validateOnBlur = false,
  children,
  enableReinitialize = true,
  validateOnMount = false,
  validateOnChange = true,
}: FormikConfig<T>) => {
  const [submitCount, setSubmitCount] = useState(0)
  const handleSubmit = (values: T, formikHelpers?: FormikHelpers<T>) => {
    onSubmit(changeEmptyToNull(values) as T, formikHelpers)
  }

  return (
    <Formik
      initialValues={changeNullToEmpty(initialValues)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize={enableReinitialize}
      validateOnBlur={validateOnBlur}
      validateOnMount={validateOnMount}
      validateOnChange={validateOnChange}
      initialTouched={validateOnMount && getInitialTouched(initialValues)}
    >
      {(props: FormikProps<T>) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (submitCount !== props.submitCount && !isEmpty(props.errors)) {
            const invalidField = Object.keys(props.errors)[0]
            scrollTo(`${invalidField}_field`)
            setSubmitCount(props.submitCount)
          }
        })

        return (
          <form onSubmit={props.handleSubmit} onReset={props.handleReset}>
            {typeof children === 'function' ? children(props) : children}
          </form>
        )
      }}
    </Formik>
  )
}

export default Form
